module.exports = __webpack_public_path__ + "img/logo.15663366.png";